import { Network, Swords, GitMerge, X, Save, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { PaperIdScopeKind } from "@/stores/filter-store";

interface Props {
  label: string | undefined;
  kind: PaperIdScopeKind | undefined;
  paperCount: number;
  onSaveAsWorkingSet: () => void;
  onExit: () => void;
  /** Only used when kind === "field-debate-tension". */
  onCompareTension?: () => void;
}

const ICON_FOR_KIND: Record<PaperIdScopeKind, typeof Swords> = {
  "field-debate-camp": Swords,
  "field-debate-bridges": Network,
  "field-debate-tension": GitMerge,
};

export function CampScopeBanner({
  label,
  kind,
  paperCount,
  onSaveAsWorkingSet,
  onExit,
  onCompareTension,
}: Props) {
  if (!label || !kind) return null;
  const Icon = ICON_FOR_KIND[kind];
  return (
    <div
      role="status"
      aria-label="Active reading scope"
      className="flex items-center gap-3 border-b border-indigo-500/30 bg-indigo-500/5 px-3 py-2"
    >
      <Icon className="size-4 text-indigo-400" />
      <span className="text-sm">
        <span className="text-muted-foreground">Reading: </span>
        <span className="font-medium text-foreground">{label}</span>
        <span className="text-muted-foreground"> · {paperCount} papers</span>
      </span>
      <span className="flex-1" />
      {kind === "field-debate-tension" && onCompareTension && (
        <Button size="sm" variant="ghost" onClick={onCompareTension}>
          <ArrowRight className="size-3.5 mr-1" />
          Compare across this tension
        </Button>
      )}
      <Button size="sm" variant="ghost" onClick={onSaveAsWorkingSet}>
        <Save className="size-3.5 mr-1" />
        Save as Working Set
      </Button>
      <Button size="sm" variant="ghost" onClick={onExit} aria-label="Exit scope">
        <X className="size-3.5" />
      </Button>
    </div>
  );
}
